import React from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { transactionsFetch } from '../../../../actions/transactionsActions';
import TransactionRowDesktop from './_TransactionRowDesktop';
import TransactionRowMobile from './_TransactionRowMobile';
import PropTypes from 'prop-types';
import { isMobile } from '../../../../lib/responsive';
import CheckIfAnyData from '../../../shared/CheckIfAnyData';
import Spinner from '../../../shared/_Spinner';

class Transactions extends React.Component {
  componentDidMount() {
    const { fetchTransactions, currentUserId } = this.props;

    fetchTransactions(currentUserId);
  }

  _renderTransactions = () => {
    const { transactions } = this.props;
    const items     = transactions.get('data') || Immutable.Map();
    const result    = transactions.get('result') || Immutable.List();
    const elements  = [];
    const TransactionRow = isMobile ? TransactionRowMobile : TransactionRowDesktop;

    result.forEach((id) => {
      const transaction = items.get(id) || Immutable.Map();

      elements.push(
        <TransactionRow key={ id } transaction={ transaction } />
      );
    });

    return elements;
  };

  render() {
    const { transactions } = this.props;
    const transactionsSize = transactions.get('data') ? transactions.get('data').size : 0;

    return (
      <Spinner  enabled={ transactions.get('loading') }>
        <CheckIfAnyData dataSize={ transactionsSize }>
          <div className='transactions-table'>
            {!isMobile && (
              <div className='transactions-table__header'>
                <div className='transactions-table__date'>Date</div>
                <div className='transactions-table__items'>Items</div>
                <div className='transactions-table__charge'>Charge</div>
                <div className='transactions-table__invoice'>Invoice</div>
              </div>)}
            {this._renderTransactions()}
          </div>
        </CheckIfAnyData>
      </Spinner>
    );
  }
}

Transactions.propTypes = {
  currentUserId: PropTypes.string.isRequired,
  fetchTransactions: PropTypes.func.isRequired,
  transactions: PropTypes.instanceOf(Immutable.Map).isRequired
};

const mapStateToProps = (state) => {
  return {
    currentUserId: state.getIn(['currentUser', 'data', 'id']),
    transactions: state.getIn(['transactions'], Immutable.Map())
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTransactions: (id) => {
      dispatch(transactionsFetch({ id }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);



// WEBPACK FOOTER //
// ./app/components/reps/settings/transactions/_Transactions.jsx